<div>
    <vl-title tag-name="h3">{{ title }}</vl-title>
    <vl-typography v-html="message"></vl-typography>
</div>